export const GET_ARTIST_ANALYTICS = '[ArtistAnalytics] Get artist analytics';
export const GET_ARTIST_ANALYTICS_SUCCESS =
  '[ArtistAnalytics] Get artist analytics Success';
export const GET_ARTIST_ANALYTICS_ERROR =
  '[ArtistAnalytics] Get artist analytics Error';

export const UPDATE_TIMEFRAME = '[ArtistAnalytics] Update timeframe';

export const RESET_ANALYTICS = '[ArtistAnalytics] Reset';

export const UPDATE_FIELD = '[ArtistAnalytics] Update Field';
